import { render, staticRenderFns } from "./PopupRouterViewApprovalDetail.vue?vue&type=template&id=1f8d3440&"
import script from "./PopupRouterViewApprovalDetail.vue?vue&type=script&lang=js&"
export * from "./PopupRouterViewApprovalDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports